import toLower from "mn-utils/toLower";

export const getTerminalColor = (color = '') => (toLower(color) || '').replace(' ', '_');
